import React from 'react';

import { useJobProspectsState, useJobProspectsActions } from './JobProspectsContext';
import { generateResume } from './restApi';

import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import Form from '../../Shared/UI/Form/components/Form';
import FormInstruction from '../../Shared/UI/FormInstruction/components/FormInstruction';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

const GenerateResumeBetaModal = () => {
  const state = useJobProspectsState();
  const { closeGenerateResumeModal, onResponse, onError, addGeneratingJobProspectId, removeGeneratingJobProspectId } = useJobProspectsActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']")?.getAttribute("content");

  const jobProspectId = state?.generateResumeJobProspectId;
  const isOpen = state?.generateResumeModalIsOpen;

  if (!jobProspectId) return null;

  const handleConfirm = () => {
    closeGenerateResumeModal();
    addGeneratingJobProspectId(jobProspectId);
    generateResume({
      jobProspectId,
      body: { authenticityToken },
      onResponse,
      onError: (error) => {
        removeGeneratingJobProspectId(jobProspectId);
        onError(error);
      },
    });
  };

  return (
    <StandardModal
      isOpen={isOpen}
      contentLabel="Generate Resume (Beta)"
      onRequestClose={closeGenerateResumeModal}
    >
      <Form>
        <FormInstruction>
          <strong>This feature is in beta.</strong>
          <br />
          <br />
          Resumes generated using this feature are a starting point and should not be submitted as-is. Please review and edit the resume before using it in a job application.
        </FormInstruction>

        <ResponsiveContainer name="form-actions">
          <FormActions>
            <Button
              variant="secondary"
              onClick={closeGenerateResumeModal}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={handleConfirm}
            >
              I Understand, Generate Resume
            </Button>
          </FormActions>
        </ResponsiveContainer>
      </Form>
    </StandardModal>
  );
};

export default GenerateResumeBetaModal;
